var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-today grid gap-10 grid-cols-2"},[_c('div',[_c('div',{staticClass:"form-title"},[_vm._v("Daily Tracking")]),_c('r-indicator-form',{attrs:{"date":_vm.today}})],1),_c('div',[_c('div',{staticClass:"form-title"},[_vm._v("Daily Journal")]),_c('r-journal-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }